import { useMemo } from 'react';
import type TokenAmount from '@/shared/utils/TokenAmount';
import useEvmScAccount from './useEvmScAccount';

export default function useRequiredDepositAmount(
  additionalDelegation: TokenAmount | null | undefined,
) {
  const { nextEpoch } = useEvmScAccount();

  return useMemo(() => {
    if (!additionalDelegation) return null;

    if (!nextEpoch?.undelegatedBalance) return additionalDelegation;

    if (nextEpoch.undelegatedBalance.gte(additionalDelegation)) return null;

    return additionalDelegation.sub(nextEpoch.undelegatedBalance);
  }, [additionalDelegation?.value.toString(), nextEpoch?.undelegatedBalance.value.toString()]);
}
